/* tslint:disable */
export enum CelebrityRole {Director = "Director",Actor = "Actor",Author = "Author"}
